import { t } from 'i18next'
import { OrganizationCategory, Role } from 'src/gql/graphql'

export const roleMapping = {
  HR: t('header.role.hr', 'HR'),
  EDUCATOR: t('header.role.educator', 'Educator'),
  EMPLOYEE: t('header.role.employee', 'Employee'),
  IT: t('admin.title', 'Admin'),
  MANAGER: t('header.role.manager', 'Manager'),
}

const createRoleMapping = (prefix: string) => ({
  [Role.Hr]: t(`resources.roleMapping.${prefix}.hr`, 'HR'),
  [Role.It]: t(`resources.roleMapping.${prefix}.admin`, 'Admin'),
  [Role.Manager]: t(`resources.roleMapping.${prefix}.manager`, 'Manager'),
  [Role.Employee]: t(`resources.roleMapping.${prefix}.employee`, 'Employee'),
  [Role.Educator]: t(`resources.roleMapping.${prefix}.educator`, 'Educator'),
})

type ExcludedCategories = OrganizationCategory.All

type RoleMappingType = Record<
  Exclude<OrganizationCategory, ExcludedCategories>,
  Record<Role, string>
>

const roleMappings: RoleMappingType = {
  [OrganizationCategory.Company]: createRoleMapping('company'),
  [OrganizationCategory.Government]: createRoleMapping('gov'),
  [OrganizationCategory.Ngo]: createRoleMapping('ngo'),
  [OrganizationCategory.Community]: createRoleMapping('company'),
  [OrganizationCategory.Family]: createRoleMapping('family'),
  [OrganizationCategory.Personal]: createRoleMapping('family'),
}

export const employeeViewTranslationByOrgType = {
  [OrganizationCategory.Company]: t('header.employeeView', 'Employee View'),
  [OrganizationCategory.Government]: t('header.employeeView', 'Employee View'),
  [OrganizationCategory.Ngo]: t('resources.roleMapping.view.member'),
  [OrganizationCategory.Family]: t('resources.roleMapping.view.member'),
  [OrganizationCategory.Personal]: t('resources.roleMapping.view.member'),
  [OrganizationCategory.Community]: t('header.employeeView'),
}

export const getRoleMapping = (
  orgType?: OrganizationCategory,
): Record<Role, string> =>
  orgType
    ? roleMappings[orgType as Exclude<OrganizationCategory, ExcludedCategories>]
    : roleMapping
